import ArticleIntro from "@/components/ArticleIntro";
import BlogPostsOverview from "@/components/BlogPostsOverview";
import CountdownComponent from "@/components/CountdownComponent";
import CourseLibrary from "@/components/CourseLibrary";
import Faq from "@/components/Faq";
import Header from "@/components/Header";
import HeroText from "@/components/HeroText";
import ImageComponent from "@/components/ImageComponent";
import InfoCarousel from "@/components/InfoCarousel";
import LeaderboardWrapper from "@/components/LeaderboardWrapper";
import OOMLeaderboard from "@/components/OOMLeaderboard";
import Page from "@/components/Page";
import PageBanner from "@/components/PageBanner";
import Partners from "@/components/Partners";
import PlayerCarousel from "@/components/PlayerCarousel";
import PrizeList from "@/components/PrizeList/PrizeList";
import Schedule from "@/components/Schedule";
import SeasonSummary from "@/components/SeasonSummary";
import SocialMediaWidget from "@/components/SocialMediaWidget";
import Tabs from "@/components/Tabs";
import TeaserList from "@/components/TeaserList";
import TeaserRow from "@/components/TeaserRow";
import Testimonials from "@/components/Testimonials";
import TextBox from "@/components/TextBox";
import TextComponent from "@/components/TextComponent";
import TextWithMedia from "@/components/TextWithMedia";
import TextWithMediaSmall from "@/components/TextWithMediaSmall";
import TournamentCardOverview from "@/components/TournamentCard/TournamentCardOverview";
import VideoComponent from "@/components/VideoComponent";
import YouTubePlaylist from "@/components/YouTubePlaylist";


export const components = {
  page: Page,
  article_intro: ArticleIntro,
  page_banner: PageBanner,
  text_component: TextComponent,
  text_with_media: TextWithMedia,
  teaser_row: TeaserRow,
  course_library: CourseLibrary,
  info_carousel: InfoCarousel,
  image_component: ImageComponent,
  prize_list: PrizeList,
  video_component: VideoComponent,
  text_with_media_small: TextWithMediaSmall,
  countdown: CountdownComponent,
  leaderboards: LeaderboardWrapper,
  oom_leaderboard: OOMLeaderboard,
  partners: Partners,
  header: Header,
  blog_posts_overview: BlogPostsOverview,
  tournament_card_overview: TournamentCardOverview,
  text_box: TextBox,
  faq: Faq,
  tabs: Tabs,
  player_carousel: PlayerCarousel,
  teaser_list: TeaserList,
  hero_text: HeroText,
  schedule: Schedule,
  season_summary: SeasonSummary,
  testimonials: Testimonials,
  social_media_widget: SocialMediaWidget,
  youtube_playlist: YouTubePlaylist,
};
